export const SITE_NAME = 'Pingscalate'
export const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined) ?? 'https://pingscalate.com'
export const SITE_TAGLINE = 'Uptime monitoring with Slack and email alerts'
export const OG_IMAGE_PATH = '/og-image.svg'

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${SITE_URL.replace(/\/$/, '')}${normalized}`
}
